import { FC } from "react"
import If from "../../../if"
import NameCell from "./cells/name"
import Table from "../../../table"
import { BBColumnDef, Brand, RateCardsConfig } from "../../../../../types"

interface Props {
  data: RateCardsConfig[]
  brands: Brand[]
  isFetching: boolean
  onSelect: (id: string) => void
}

const RateCardsConfigTable: FC<Props> = ({
  data,
  brands,
  isFetching,
  onSelect
}) => {
  const columns: BBColumnDef<RateCardsConfig>[] = [
    {
      id: "name",
      header: "Name",
      accessorFn: row => row.name,
      footer: props => props.column.id,
      cell: props => (
        <NameCell
          info={props.row.original}
          brands={brands}
          onSelect={onSelect}
        />
      )
    }
  ]

  return (
    <div>
      <If
        condition={!data?.length && !isFetching}
        then={
          <div className="text-sm text-gray-500">
            No rate cards configs found.
          </div>
        }
        else={
          <Table
            isLoading={isFetching}
            data={data}
            columns={columns}
            viewType="table"
            shrinkFilterSort
            noHeader
            searchBarVisible={false}
            defaultSortBy="name"
            defaultSortDir="asc"
          />
        }
      />
    </div>
  )
}

export default RateCardsConfigTable
